/**
 * Whether this tab's build is one the venue still serves — `docs/06` §F132.
 *
 * A release that changes the settlement contract changes the EIP-712 domain
 * every order is signed under. A tab that loaded before it holds the old
 * domain (and, on a pinned build, the old contract address), so every order it
 * signs is refused. The venue publishes the oldest build it still serves as
 * `/config.min_client_build`, and a tab older than that reloads itself. The
 * release raises it only inside its maintenance minute, when nobody can trade
 * anyway, so the reload costs nothing a user could have done meanwhile.
 *
 * **A build stamps itself `<UTC commit time YYYYMMDDHHMMSS>-<short commit>`**,
 * which orders by its first part. A build that stamps nothing recognisable —
 * a developer's `0.0.0-dev` — never reloads: there is nothing to compare, and a
 * page that reloads itself for ever is worse than one that is out of date.
 */

const STAMP = /^(\d{14})-[0-9a-f]{4,40}$/

/** The ordering part of a build stamp, or `null` when it is not one. */
export function buildTime(build: string | null | undefined): string | null {
  const m = build ? STAMP.exec(build) : null
  return m ? m[1]! : null
}

/**
 * True when `own` is a stamped build older than the stamped `minimum`.
 *
 * Fourteen digits compare as strings exactly as they compare as numbers, which
 * keeps this free of a number that could round.
 */
export function buildIsTooOld(own: string, minimum: string | null | undefined): boolean {
  const mine = buildTime(own)
  const floor = buildTime(minimum)
  if (mine === null || floor === null) return false
  return mine < floor
}
